<template>
  <modal :showModal="showModal" id="tranche-details" @close="close">
    <template slot="modal-header">
      <h5 class="bold">Szczegóły wpłaty {{ tranche.token }}</h5>
    </template>

    <template slot="modal-body">
      <div class="saldo">
        <stats-indicator icon="mfind-icon-wallet"
          :stats="tranche.amount | currency" >
          <template slot="header">
            <h6>Kwota wynagrodzenia</h6>
          </template>
        </stats-indicator>
      </div>
      <div class="line">
        <div class="inside-line">
          Dane do wysłania
        </div>
      </div>
      <invoice-details :token="tranche.token" />

      <div class="line status-changes-details">
        <div class="inside-line">
          Szczegóły aktualizacji statusu
        </div>
      </div>
      <table class="highlight centered">
        <thead>
          <tr>
            <th>Data aktualizacji</th>
            <th>Status</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="change in tranche.changes">
            <td>{{ change.updated_at | date }} </td>
            <td>{{ change.status }}</td>
          </tr>
        </tbody>
      </table>
    </template>

    <template slot="modal-footer">
      <button class="btn btn-large" @click="close">
        <i class="mfind-icon-back"></i> Zamknij
      </button>
    </template>
  </modal>
</template>

<script>
  import InvoiceDetails from '@/components/invoiceDetails'
  import StatsIndicator from '@/components/statsIndicator'
  import Loader from '@/components/loader'
  import Modal from '@/components/modal'
  export default {
    props: ['tranche', 'showModal'],
    components: { Loader, Modal, StatsIndicator, InvoiceDetails },
    methods: {
      close: function () {
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss">
  @import 'src/components/modal';

  #tranche-details {
    .token-value, .amount-value {
      margin: 5px 0;

      span {
        font-weight: bold;
      }
    }
    .saldo {
      background-color: #fafafc;
      border: 1.4px solid #ecf0f6;
      border-radius: 6px;
      display: inline-block;
      padding: 5px 40px;

      .stats-indicator {
        padding: 10px 0 30px;
      }
      h6 {
        line-height: 2rem;
      }
    }
    .status-changes-details .inside-line {
      width: 220px;
    }
    table thead {
      background-color: #f7f7f7;
    }
  }
</style>



// WEBPACK FOOTER //
// modalTrancheHistory.vue?0f78cfdf